import React from 'react';
import { AddSaveContactDto } from '../../../types';
import X from '../../../assets/icons/new_icon/x.svg';
import contact from '../../../assets/icons/new_icon/contact.svg';
interface Props {
  onClose: any;
  savedContactForm: AddSaveContactDto;
  setSavedContactForm: React.Dispatch<React.SetStateAction<AddSaveContactDto>>;
  onSave: any;
  title?: any;
}
function SaveContactModal({
  onClose,
  savedContactForm,
  setSavedContactForm,
  onSave,
  title,
}: Props) {
  const handleClose = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div
      className='modal'
      id='contact_modal'
      style={{ display: 'block', backgroundColor: 'rgba(0, 0, 0, 0.5) ' }}
      tabIndex={-1}
      role='dialog'
      aria-labelledby='quoteModalLabel'
      aria-hidden='true'
      onClick={handleClose}
    >
      <div
        className='modal-dialog modal-dialog-centered modal-md'
        role='document'
      >
        <div className='modal-content' style={{ borderRadius: '8px' }}>
          <div className='modal-header d-flex w-100 justify-content-between px-3 py-2'>
            <h3 className='newubbemodalheading  mt-3'>
              {title ? title : 'Save Contact'}
            </h3>
            <img
              src={X}
              onClick={() => onClose()}
              style={{ cursor: 'pointer' }}
            />
          </div>
          {/* <div className=' m-auto flex-column  d-flex justify-content-center '>
            {' '}
            <img
              src={contact}
              className=' m-auto my-4'
              style={{ width: '91px' }}
            />
            <h2 className='lex-black-18-300 mb-0'>
              {' '}
              Please Provide a Title for Your Address
            </h2>
          </div> */}
          <div className='modal-body pt-0 px-3'>
            {/* <div className='row'>
              <div className='col-md-12'>
                <div className='form-group text-left'>
                  <label className='col-sm-12  col-form-label globalInputLabel my-auto'>
                    Contact Name{' '}
                    <span
                      className='text-danger fw-bold'
                      style={{ marginLeft: '4px' }}
                    >
                      *
                    </span>
                  </label>
                  <input
                    id='nick_name'
                    type='text'
                    className='form-control ubbe-input'
                    placeholder='Name your contact'
                    maxLength={30}
                    value={savedContactForm.username}
                    onChange={(e) => {
                      setSavedContactForm({
                        ...savedContactForm,
                        username: e.target.value,
                      });
                    }}
                  />
                </div>
              </div>
            </div> */}
            <div className='d-flex gap-3  align-items-center my-4'>
              <div className=' text-center'>
                <div className='form-check d-flex gap-1'>
                  <input
                    type='checkbox'
                    className='form-check-input'
                    id='is_origin'
                    checked={savedContactForm.is_origin}
                    onChange={(e) => {
                      setSavedContactForm({
                        ...savedContactForm,
                        is_origin: e.target.checked,
                      });
                    }}
                  />
                  <label
                    className='form-check-label  globalInputLabel'
                    style={{ fontWeight: '300' }}
                    htmlFor='is_origin'
                  >
                    Show in origin?
                  </label>
                </div>
              </div>
              <div className=' text-center'>
                <div className='form-check d-flex gap-1'>
                  <input
                    type='checkbox'
                    className='form-check-input'
                    style={{ fontWeight: '300' }}
                    id='is_destination'
                    checked={savedContactForm.is_destination}
                    onChange={(e) => {
                      setSavedContactForm({
                        ...savedContactForm,
                        is_destination: e.target.checked,
                      });
                    }}
                  />
                  <label
                    className='form-check-label  globalInputLabel'
                    style={{ fontWeight: '300' }}
                    htmlFor='is_destination'
                  >
                    Show in destination?
                  </label>
                </div>
              </div>
            </div>

            <div className='row mt-3'>
              <div className='col-sm-12'>
                <p
                  className='btn ubbe-blue-bg p-2 px-4 w-100 rounded-3 text-light d-flex m-auto justify-content-center align-items-center mb-2'
                  style={{ maxWidth: 'max-content', height: '48px' }}
                  onClick={() => {
                    onSave();
                  }}
                >
                  Save Contact
                </p>
                <u
                  className='m-auto d-flex justify-content-center labelText'
                  style={{ cursor: 'pointer' }}
                  aria-label='Close'
                  onClick={() => onClose()}
                >
                  Cancel
                </u>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SaveContactModal;
